import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { SymbolAssetsAction } from './symbolAssets.action';
import { symbolAssetsInitialState } from './symbolAssets.constant';

export const symbolAssetsReducer = reducerWithInitialState(symbolAssetsInitialState)
  .case(SymbolAssetsAction.load.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(SymbolAssetsAction.load.done, (state, payload) => {
    return {
      ...state,
      list: payload.result,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(SymbolAssetsAction.load.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(SymbolAssetsAction.destroy, () => ({
    ...symbolAssetsInitialState,
  }));
